import React from "react";
import { Grid, Cell, Name, Location, Criteria } from "./styled/photo-card-data";
function PhotoCardData(_a) {
    var name = _a.name, lineOne = _a.lineOne, _b = _a.lineTwo, lineTwo = _b === void 0 ? ["", "", ""] : _b, lineTwoFallback = _a.lineTwoFallback, shouldHaveTwoLines = _a.shouldHaveTwoLines, hasLineTwo = _a.hasLineTwo, hasLineTwoFallback = _a.hasLineTwoFallback;
    return (React.createElement(Grid, null,
        React.createElement(Cell, null,
            name && React.createElement(Name, null, name),
            !name && React.createElement(Name, { noData: true }, "No Name")),
        React.createElement(Cell, null,
            lineOne && React.createElement(Location, null, lineOne),
            !lineOne && React.createElement(Location, { noData: true }, "No Location")),
        React.createElement(Cell, null,
            hasLineTwo && (React.createElement(Criteria, null, lineTwo.map(function (item, index) { return (React.createElement("span", { key: index },
                index > 0 ? React.createElement(React.Fragment, null, " \u2022 ") : null,
                item)); }))),
            !hasLineTwo && hasLineTwoFallback && (React.createElement(Criteria, null, lineTwoFallback)),
            shouldHaveTwoLines && !hasLineTwo && !hasLineTwoFallback && (React.createElement(Criteria, { noData: true }, "No Criteria")))));
}
export default PhotoCardData;
